import React from 'react'
import AppRoutes from './routes/AppRoutes'
import { LangProvider } from './context/LangContext'
import { SiteProvider } from './context/SiteContext'
import { AuthProvider } from './context/AuthContext'

function App() {
  return (
    <LangProvider>
      <SiteProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </SiteProvider>
    </LangProvider>
  )
}

export default App
